var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDzenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 415,
    height: 415,
    viewBox: "0 0 415 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14940_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.454 9.20556C316.795 9.20556 405.704 98.1312 405.704 207.493C405.704 316.855 316.795 405.781 207.454 405.781C98.1127 405.781 9.20381 316.855 9.20381 207.493C9.20381 98.1312 98.1127 9.20556 207.454 9.20556ZM207.454 0C92.8665 0 0 92.8841 0 207.493C0 322.102 92.8665 414.986 207.454 414.986C322.041 414.986 414.908 322.102 414.908 207.493C414.908 92.8841 322.041 0 207.454 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 204.53C332 203.28 330.984 202.245 329.734 202.187C284.885 200.488 257.589 194.767 238.494 175.669C219.359 156.533 213.658 129.215 211.959 84.2651C211.92 83.0154 210.885 82 209.616 82H204.383C203.134 82 202.099 83.0154 202.04 84.2651C200.342 129.196 194.64 156.533 175.506 175.669C156.391 194.786 129.114 200.488 84.2649 202.187C83.0153 202.226 82 203.261 82 204.53V209.763C82 211.013 83.0153 212.048 84.2649 212.106C129.114 213.805 156.41 219.526 175.506 238.623C194.601 257.721 200.303 284.961 202.021 329.734C202.06 330.984 203.095 332 204.364 332H209.616C210.866 332 211.9 330.984 211.959 329.734C213.677 284.961 219.379 257.721 238.474 238.623C257.589 219.507 284.865 213.805 329.715 212.106C330.965 212.067 331.98 211.032 331.98 209.763V204.53H332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14940_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 415,
    height: 415,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzenWhite);
export default __webpack_public_path__ + "static/media/dzen_white.a2abc36ddfb5ed3b13d893ba9ab785c6.svg";
export { ForwardRef as ReactComponent };